import React from "react";
import { useLanguage } from "../LanguageContext";
import "./Whoweare.css";

const AboutWhoweare2 = () => {
  const { language } = useLanguage();
  return (
    <>
      <div className="about-partners">
        <div className="proscope-content">
          <h2 className="proscope-about-heading">
            {language === "en" ? <>Our Team</> : <>ทีมของเรา</>}
          </h2>
          <p className="proscope-about-description">
            {language === "en" ? (
              <>
                Proscope is powered by a multidisciplinary team of certified
                engineers, solution architects, developers, and consultants who
                bring both depth and breadth of knowledge to every engagement.
                We foster a culture of{" "}
                <strong> continuous learning and certification, </strong>
                ensuring our team stays ahead in fast-evolving areas such as:
                <ul className="proscope-about-list">
                  <li>Cloud & Hybrid Architecture</li>
                  <li>Network Security & Infrastructure</li>
                  <li>Open Source ERP (e.g., Odoo)</li>
                  <li>Automation & DevOps</li>
                  <li>AI-driven Monitoring and Insights</li>
                </ul>
                <br />
                <strong> Industries We Serve </strong>
                <br />
                <br />
                With more than a decade of experience, we support organizations
                across sectors such as:
                <ul className="proscope-about-list">
                  <li>
                    {" "}
                    <strong> Manufacturing </strong> — with scalable,
                    production-ready IT
                  </li>
                  <li>
                    {" "}
                    <strong> Healthcare </strong> — with secure,
                    high-availability systems
                  </li>
                  <li>
                    <strong> Education </strong> — with hybrid learning and IT
                    lifecycle support
                  </li>
                  <li>
                    {" "}
                    <strong> Hospitality </strong> — with fast, reliable guest
                    systems
                  </li>
                  <li>
                    <strong> Finance </strong> — with compliance-ready,
                    cost-effective platforms
                  </li>
                </ul>
                <br />
                No matter the industry, we adapt to the scale, vision, and pace
                of each client. Whether you're a growing SME or an enterprise
                with global operations, we adapt our solutions to your scale,
                budget, and business direction.
              </>
            ) : (
              <>
                ทีมของ Proscope ประกอบด้วยวิศวกร ผู้เชี่ยวชาญระบบ นักพัฒนา
                และที่ปรึกษาที่มีความรู้หลากหลายและลึกซึ้ง
                เราสร้างวัฒนธรรมการเรียนรู้อย่างต่อเนื่อง
                และสนับสนุนการพัฒนาใบรับรองวิชาชีพ
                เพื่อให้พร้อมกับโลกเทคโนโลยีที่เปลี่ยนแปลงตลอดเวลา
                <br />
                <br />
                <strong> ความเชี่ยวชาญของเราครอบคลุม: </strong>
                <ul className="proscope-about-list">
                  <li>โครงสร้างพื้นฐาน Cloud และ Hybrid</li>
                  <li>ระบบเครือข่ายและความปลอดภัย</li>
                  <li>ระบบ ERP แบบ Open Source (เช่น Odoo)</li>
                  <li>Automation และ DevOps</li>
                  <li>ระบบมอนิเตอร์ด้วย AI และข้อมูลเชิงลึก</li>
                </ul>
                <br />
                <strong>อุตสาหกรรมที่เราให้บริการ</strong>
                <br />
                <br />
                ตลอดเวลากว่า 10 ปีที่ผ่านมา
                เราได้ทำงานร่วมกับองค์กรในหลายภาคส่วน เช่น:
                <ul className="proscope-about-list">
                  <li>
                    อุตสาหกรรมการผลิต – ระบบพร้อมใช้งานที่สามารถขยายตัวได้
                  </li>
                  <li>โรงพยาบาลและสุขภาพ – ระบบที่ปลอดภัยและมีเสถียรภาพ</li>
                  <li>
                    การศึกษา – ระบบสำหรับการเรียนรู้แบบ Hybrid
                    และสนับสนุนวงจรชีวิตไอที
                  </li>
                  <li>
                    ธุรกิจบริการ/โรงแรม – ระบบเครือข่ายที่เสถียรและใช้งานง่าย
                  </li>
                  <li>
                    การเงิน –
                    โซลูชันที่พร้อมด้านความปลอดภัยและสอดคล้องกับข้อกำหนด
                  </li>
                </ul>
                ไม่ว่าองค์กรจะขนาดเล็กหรือใหญ่ เราปรับให้สอดคล้องกับงบประมาณ
                วิสัยทัศน์ และเป้าหมายของลูกค้าเสมอ
              </>
            )}
          </p>

          <h3 className="proscope-about-heading">
            {language === "en" ? <> What We Do</> : <>สิ่งที่เราทำ</>}
          </h3>
          <p className="proscope-about-description">
            {language === "en" ? (
              <>
                We deliver end-to-end IT solutions tailored to real business
                needs — not vendor agendas. Our offerings include:
                <ul className="proscope-about-list">
                  <li>IT Planning & Strategic Consulting</li>
                  <li>Infrastructure Design & Deployment</li>
                  <li>Cloud Transformation & Hybrid Integration</li>
                  <li>Cybersecurity Assessment & Implementation</li>
                  <li>ERP Setup & Custom Development</li>
                  <li>Web & Application Solutions</li>
                  <li>
                    Maintenance Services (including hardware spare part
                    programs)
                  </li>
                </ul>
                <br />
                We also believe that the best solutions don't just solve
                technical problems. They should reduce cost, improve
                productivity, and provide flexibility for future growth.
              </>
            ) : (
              <>
                เรานำเสนอ “โซลูชันแบบครบวงจร” ที่ออกแบบมาเพื่อธุรกิจจริง —
                ไม่ใช่ตามแรงผลักของ Vendor โซลูชันของเราครอบคลุม:
                <ul className="proscope-about-list">
                  <li>การวางแผนและที่ปรึกษาด้านไอที</li>
                  <li>การออกแบบและติดตั้งระบบโครงสร้างพื้นฐาน</li>
                  <li>การเปลี่ยนผ่านสู่ระบบ Cloud และ Hybrid</li>
                  <li>การประเมินและจัดการด้านความปลอดภัย (Cybersecurity)</li>
                  <li>การติดตั้งและปรับแต่งระบบ ERP</li>
                  <li>การพัฒนาเว็บไซต์และแอปพลิเคชัน</li>
                  <li>บริการดูแลรักษาระบบ (รวมถึงอะไหล่สำรอง)</li>
                </ul>
                เราเชื่อว่าโซลูชันที่ดีไม่ใช่แค่ “ทำงานได้” แต่ควรช่วยลดต้นทุน
                เพิ่มประสิทธิภาพ และวางรากฐานสำหรับอนาคต
              </>
            )}
          </p>

          <h3 className="proscope-about-heading">
            {language === "en" ? (
              <> Why Clients Stay With Us</>
            ) : (
              <>ทำไมลูกค้าถึงเลือกเรา... และอยู่กับเรานาน</>
            )}
          </h3>
          <p className="proscope-about-description">
            {language === "en" ? (
              <>
                <ul className="proscope-about-list">
                  <li>
                    We prioritize <strong> long-term partnerships </strong>over
                    short-term wins
                  </li>
                  <li>
                    We speak with <strong> clarity and transparency, </strong>
                    not jargon
                  </li>
                  <li>
                    We’re built on <strong> integrity, </strong>and we stand
                    behind our work
                  </li>
                  <li>
                    We’re always learning, always improving —{" "}
                    <strong> together with our clients </strong>
                  </li>
                </ul>
                <br />
                At Proscope, we don’t just build systems.
                <br />
                We build confidence, clarity, and forward momentum — for the
                people we work with, and the purpose we believe in.
              </>
            ) : (
              <>
                <ul className="proscope-about-list">
                  <li>เพราะเรามอง “ระยะยาว” มากกว่า “จบโปรเจกต์”</li>
                  <li>เพราะเราพูดด้วยความชัดเจน ไม่ซับซ้อน</li>
                  <li>เพราะเรายึดมั่นในความซื่อสัตย์ และกล้ารับผิดชอบ</li>
                  <li>เพราะเราพัฒนาและเรียนรู้ไปพร้อมกับลูกค้าเสมอ</li>
                </ul>
                ที่ Proscope เราไม่ได้แค่สร้างระบบ
                <br />
                แต่เราสร้าง “ความเชื่อมั่น” “ความเข้าใจ” และ “ทิศทางที่ชัดเจน”
                ให้กับผู้ที่เราทำงานด้วย — และเป้าหมายที่เราร่วมกันผลักดัน
              </>
            )}
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutWhoweare2;
